export enum VehicleTypeEnum {
    fourwheel = 'fourwheel',
    sedan = 'sedan',
    break = 'break',
    citycar = 'citycar',
    coupe = 'coupe',
    crossover = 'crossover',
    van = 'van',
    monospace = 'monospace',
    pickup = 'pickup',
    outOfClass = 'outOfClass',
}

export interface VehicleType {
    id: number;
    documentId?: string;
    name: string;
    depth?: number;
    width?: number;
    height?: number;
    weight?: number;
    typeRef?: VehicleTypeEnum;
}

// ponytail: the API returns the enum key in `name`, not `typeRef` — read the ref through here.
export const nameOf = (vehicleType: VehicleType): string =>
    vehicleType?.name

export enum VehicleMakerEnum {
        alfa_romeo= 'Alfa Romeo',
        audi= 'Audi',
        bmw= 'BMW',
        chevrolet= 'Chevrolet',
        chrysler= 'Chrysler',
        citroen= 'Citroen',
        cupra= 'Cupra',
        dacia= 'Dacia',
        ds= 'DS',
        fiat= 'Fiat',
        ford= 'Ford',
        gmc= 'GMC',
        honda= 'Honda',
        hyundai= 'Hyundai',
        kia= 'KIA',
        jaguar= 'Jaguar',
        jeep= 'Jeep',
        lancia= 'Lancia',
        land_rover= 'Land Rover',
        lexus= 'Lexus',
        mazda= 'Mazda',
        mercedes= 'Mercedes',
        mg= 'MG',
        mini= 'Mini',
        mitsubishi= 'Mitsubishi',
        nissan= 'Nissan',
        opel= 'Opel',
        peugeot= 'Peugeot',
        porsche= 'Porsche',
        renault= 'Renault',
        saab= 'Saab',
        seat= 'Seat',
        skoda= 'Skoda',
        smart= 'Smart',
        suzuki= 'Suzuki',
        tesla= 'Tesla',
        toyota= 'Toyota',
        volkswagen= 'Volkswagen',
        volvo= 'Volvo'
}

export interface Vehicle {
    documentId?: string;
    maker: VehicleMakerEnum;
    model: string;
    year?: number;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    color?: string;
    licensePlate?: string;
    vehicleType: VehicleType;
    licensePlateCountryCode?: string;
}

// GET /vehicles/external-api-lookup response shape — raw values from the national registry,
// before mapping onto Vehicle (brand is a free string, vehicleType a VehicleTypeEnum key).
export interface VehicleLookupResult {
    plate: string;
    brand: string | null;
    model: string | null;
    color: string | null;
    length: number | null;
    width: number | null;
    height: number | null;
    weight: number | null;
    vehicleType: string | null;
}
